import React from 'react';

function MCOther() {
  return (
    <div className="page-container">
      <h1>Other</h1>
    </div>
  );
}

export default MCOther;
